function getChevronRotation(_ref) {
  var dir = _ref.dir,
    orientation = _ref.orientation,
    direction = _ref.direction;
  if (direction === "previous") {
    return orientation === "horizontal" ? 90 * (dir === "ltr" ? 1 : -1) : -180;
  }
  return orientation === "horizontal" ? 90 * (dir === "ltr" ? -1 : 1) : 0;
}
export { getChevronRotation };